<script>
    import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";

    export default {
        name: "SocialLinksWrapperElement",
        mixins: [AlignmentMixin],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'social-links-wrapper'
            }
        },
        computed: {
            getDefaultDataStructure() {
                return {
                    elementId: this.elementId,
                    elementType: this.elementType,
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    }
                }
            }
        },
    }
</script>